import type { FilterOptions } from '../mapFilters';
import { findHashtags } from '../utils';

const optionHasHashtag = (option: string[], hashtags: string[] | null) =>
  option.some((optionHashtag) => hashtags?.includes(optionHashtag));

export const filterByHashtag = (
  text: string | undefined,
  { exclude, include }: FilterOptions
) => {
  const flags = {
    shouldInclude: false,
    shouldExclude: false
  };

  const extractedHashtags = findHashtags(text);

  // Если есть такой хэштег, то не пускаем
  if (exclude.length) {
    flags.shouldExclude = optionHasHashtag(exclude, extractedHashtags);
  }
  // Пускаем, если есть такой hashtag в include
  if (include.length) {
    flags.shouldInclude = optionHasHashtag(include, extractedHashtags);
  }

  return flags;
};
